import React from 'react';
import { Grid, Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
    },
    drawer: {
        width: 240,
        flexShrink: 0,
    },
    drawerPaper: {
        width: 240,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    toolbar: theme.mixins.toolbar,
    title: {
        flexGrow: 1,
    },
    card: {
        minWidth: 275,
        margin: theme.spacing(2),
    },
    GridTitle: {
        display: 'flex'
    },
    TitleOne: {
        color: '#474eda',
        fontSize: '25px',
        fontWeight: 'bold',
        fontFamily: 'montserrat'
    },
    TitleNameCompany: {
        color: '#20314a',
        fontSize: '25px',
        fontFamily: 'montserrat'
    },
    GridAtualization: {
        display: 'flex'
    },
    TextAtualizationOne: {
        fontSize: '12px',
        color: '#c4c5c7',
        fontFamily: 'montserrat'
    },
    ButtonAtualization: {
        fontSize: '12px',
        color: '#c4c5c7',
        fontFamily: 'montserrat'
    }
}));

function SeuComponente({companyName}) {
    const classes = useStyles();

    return (
        <div>
            <Grid className={classes.GridTitle}>
                <Typography className={classes.TitleOne}> Colaboradores </Typography>
                <div style={{ margin: '0 5px' }}></div>
                <Typography className={classes.TitleNameCompany}> {companyName} </Typography>
            </Grid>
        </div>
    );
}

export default SeuComponente;
